import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { switchMap } from 'rxjs';
import { Teaching } from '../entities/teaching.js';
import { User } from '../entities/user.js';

export const subscribeLecturersByProduct = registerSubscription({
  operationName: 'subscribeLecturersByProduct',
  resolve:
    (productID: string) =>
    <SelSet extends BaseQLSelectionSet>(gqlFields: SelSet) =>
      watchQuery<EntityData<Teaching>>(Teaching._collectionName, { productID }, { projection: { lecturerID: 1 } }).pipe(
        switchMap(teachings => loadMongoData(User, { _id: { $in: teachings.map(teaching => teaching.lecturerID) } })),
      ),
  type: () => [User],
  params: [{ name: 'productID', type: () => String }],
});

export const getTeachingByLecturerAndProduct = registerQuery({
  operationName: 'getTeachingByLecturerAndProduct',
  resolve:
    (productID: string, lecturerID: string) =>
    async <SelSet extends BaseQLSelectionSet<Teaching>>(gelFields: SelSet) => {
      const col = await getCollection(Teaching._class);
      return (await col.find({ productID, lecturerID }).toArray())?.[0] as Maybe<Teaching>;
    },
  type: () => Teaching,
  params: [
    { name: 'productID', type: () => ID },
    { name: 'lecturerID', type: () => ID },
  ],
});
